import { useToast } from '@/components/ui';
import { isApiError } from '@/lib/api';

/** The stock windows' error toast (message and request id). */
export function useStockFail() {
  const toast = useToast();
  return (err: unknown) =>
    toast.show({
      tone: 'error',
      title: 'Not done',
      body: isApiError(err) ? err.message : undefined,
      error: err,
    });
}
